import S from 'common/service/sanctuary';
import { createSelector } from 'reselect';
import {
  collection,
} from 'common/store/selectors';

export const getScope = ({ server: { version } }) => version;
export const collectionFactory = collection.factory(getScope);

export const getVersion = createSelector(
  getScope,
  ({ version, error }) => (
    error
      ? S.Left(error)
      : S.Right(version)
  ),
);

export const isLoading = createSelector(
  getScope,
  ({ loading }) => loading,
);

export const getServersWidgetContext = collectionFactory.getResourceContext;
export const getServersWidgetMaybe = collectionFactory.getResourceMaybe;

export default {};
